import { Role } from 'auth';
import { useState } from 'react';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { ArchiveSwitch } from '@/modules/common/components/ArchiveSwitch.tsx';
import { useRegisterTypeStrings } from '@/modules/common/hooks/useRegisterTypeStrings.tsx';
import { DistributionReports } from '@/modules/issuer-dashboard/components/distribution-dashboard/DistributionReports.tsx';
import { HolderPaymentElectionChart } from '@/modules/issuer-dashboard/components/distribution-dashboard/HolderPaymentElectionChart.tsx';
import { PastDistributionsTable } from '@/modules/issuer-dashboard/components/distribution-dashboard/PastDistributionsTable.tsx';
import { PendingDistributionsTable } from '@/modules/issuer-dashboard/components/distribution-dashboard/PendingDistributionsTable.tsx';
import { PageLayout } from 'ui';

const IssuerDistributionDashboard = () => {
  const getRegisterTypeStrings = useRegisterTypeStrings();
  const [isDeleted, setIsDeleted] = useState<boolean | undefined>();
  return (
    <PageLayout
      title={getRegisterTypeStrings('Dividend', { capitalize: true, plural: true })}
      headerAction={
        <>
          <ArchiveSwitch
            active={!!isDeleted}
            onChange={active => setIsDeleted(active || undefined)}
          />
        </>
      }
      contentClassName=""
    >
      <div className="flex flex-col gap-6 pb-4 w-full">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <DistributionReports />
          <HolderPaymentElectionChart />
        </div>
        <PendingDistributionsTable isDeleted={isDeleted} />

        <PastDistributionsTable isDeleted={isDeleted} />
      </div>
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerDistributionDashboard, [
  Role.SR_ISSUER,
  Role.SR_ISSUER_ADMIN,
]);
